/**
 * Project panel
 *
 * Created by stefensuhat on 26/07/18 3.56 PM
 */

import { makeStyles, Paper, Toolbar } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import Progress from './Progress';

const propTypes = { children: PropTypes.node.isRequired, loading: PropTypes.bool };
const defaultProps = { loading: false };
const styles = makeStyles(({ spacing }) => ({
    toolbar: {
        justifyContent: 'space-between',
        marginBottom: spacing(1),
    },
    infiniteScroll: { height: 500, overflow: 'scroll' },
}));

function Card({ tool, children, loading, infiniteScroll }) {
    const classes = styles();

    return (
        <div>

            {tool && (
                <Toolbar disableGutters className={classes.toolbar}>
                    {tool}
                </Toolbar>
            )}

            {loading ? <Progress />
                : (
                    <Paper>
                        <div className={infiniteScroll && classes.infiniteScroll}>
                            {children}
                        </div>
                    </Paper>
                )}
        </div>
    );
}

Card.displayName = 'Card';
Card.propTypes = propTypes;
Card.defaultProps = defaultProps;

export default Card;
